// MARK: used in v2
export const REASON_NOT_AVAILABLE_MAPPING: Record<string, string> = {
  out_of_stock: "Out of stock",
  pre_order_only: "Pre-order only",
}

export { DEFAULT_STOREFRONT } from "../utils/V2/consolidateItem"
